import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const networkBaseFieldPack: FieldPack = {
  id: 'network-base',
  name: 'Core Resource Identity',
  description: 'Essential resource identification and location',
  version: '1.0.0',
  fields: [
    {
      id: 'name',
      label: 'Name',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 100,
      required: true,
      sensitivity: 'public',
    },
    {
      id: 'resourceId',
      label: 'Resource ID / ARN',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 95,
      required: true,
      sensitivity: 'internal',
    },
    {
      id: 'resourceType',
      label: 'Resource Type',
      type: FieldType.SELECT,
      tags: ['identity'],
      priority: 90,
      options: [
        { value: 'vpc', label: 'VPC' },
        { value: 'subnet', label: 'Subnet' },
        { value: 'ec2', label: 'EC2 Instance' },
        { value: 'rds', label: 'RDS Instance' },
        { value: 's3', label: 'S3 Bucket' },
        { value: 'lambda', label: 'Lambda Function' },
        { value: 'alb', label: 'Application Load Balancer' },
        { value: 'nlb', label: 'Network Load Balancer' },
        { value: 'igw', label: 'Internet Gateway' },
        { value: 'nat', label: 'NAT Gateway' },
        { value: 'sg', label: 'Security Group' },
        { value: 'iam-role', label: 'IAM Role' },
        { value: 'kms', label: 'KMS Key' },
        { value: 'ecs', label: 'ECS Service' },
        { value: 'eks', label: 'EKS Cluster' },
        { value: 'cloudfront', label: 'CloudFront Distribution' },
        { value: 'route53', label: 'Route53 Zone' },
      ],
      sensitivity: 'public',
    },
    {
      id: 'service',
      label: 'AWS Service',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 85,
      sensitivity: 'public',
    },
    {
      id: 'region',
      label: 'Region',
      type: FieldType.TEXT,
      tags: ['location'],
      priority: 80,
      sensitivity: 'public',
    },
    {
      id: 'az',
      label: 'Availability Zone',
      type: FieldType.TEXT,
      tags: ['location'],
      priority: 75,
      sensitivity: 'public',
    },
    {
      id: 'accountId',
      label: 'Account ID',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 70,
      sensitivity: 'internal',
    },
  ],
};
